// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});


// function enforceLinkedOptions() {
//   const groups = [...document.querySelectorAll('[data-option-buttons]')];

//   // Iterate IN ORDER: Option 1 → Option 2 → Option 3 ...
//   groups.forEach((group, i) => {
//     const buttons = [...group.querySelectorAll('[data-button]')];
//     if (!buttons.length) return;

//     const selected = buttons.find(b => b.classList.contains('selected'));
//     const availableButtons = buttons.filter(b => !b.classList.contains('disabled'));

//     // --- Case 1: selected is valid → nothing to fix ---
//     if (selected && !selected.classList.contains('disabled')) return;

//     // --- Case 2: selected is invalid → auto-select first valid ---
//     const fallback = availableButtons[0];
//     if (fallback) {
//       fallback.click();
//     }
//   });
// }



// MASTER FAILSAFE - Never fails, self-heals
let linkedOptionsTimer = null;
let validationTimer = null;

function enforceLinkedOptionsFailSafe() {
  clearTimeout(linkedOptionsTimer);

  // Run after Stiletto finishes applying disabled states
  linkedOptionsTimer = setTimeout(() => {
    applyLinkedFix();
    // Run second pass to guarantee consistency
    validationTimer = setTimeout(applyLinkedFix, 10);
  }, 70); // sweet spot: 60–100ms
}

function applyLinkedFix() {
  const groups = [...document.querySelectorAll('[data-option-buttons]')];

  groups.forEach(group => {
    const buttons = [...group.querySelectorAll('[data-button]')];
    if (!buttons.length) return;

    const selected = buttons.find(b => b.classList.contains('selected'));
    const validButtons = buttons.filter(b => !b.classList.contains('disabled'));

    // CASE 1: Valid selection exists → do nothing
    if (selected && !selected.classList.contains('disabled')) return;

    // CASE 2: Invalid selection → auto-select fallback
    const fallback = validButtons[0];

    // CASE 3: No valid buttons → DO NOTHING (product unavailable)
    if (!fallback) return;

    // Safe-click: prevents infinite loops
    if (!fallback.classList.contains('selected')) {
      fallback.click();
    }
  });
}



document.addEventListener("DOMContentLoaded", () => {
  console.log("HELLO MS 1");
  // setTimeout(enforceLinkedOptions, 300);
  // enforceLinkedOptionsFailSafe();
});


// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("HELLO MS 2");
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  // setTimeout(enforceLinkedOptions, 50);
  // enforceLinkedOptionsFailSafe();
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


// ---------------------------------------------------------------------------
// Product gallery: auto-play video when its thumbnail is clicked, and pause
// any other product video. The theme already pauses the previously-playing
// media inside `_switchCurrentImage` and toggles the `.hidden` class so the
// matching `.product__media-item` becomes visible — but it never *plays* the
// newly shown video. This delegated handler runs on the bubbling phase, i.e.
// AFTER the theme's element-level thumbnail handler has already swapped which
// media item is visible, so we can read the now-visible item and play it.
// ---------------------------------------------------------------------------
(function () {
  function pauseAllExcept(scope, keepVideo) {
    scope.querySelectorAll(".product__media-item video").forEach(function (v) {
      if (v !== keepVideo) {
        try {
          v.pause();
        } catch (err) {}
      }
    });
  }

  function playProductVideoForThumbnail(thumb) {
    var thumbnailId = thumb.dataset.thumbnailId;
    if (!thumbnailId) return;

    // Scope to the current product so multiple products on a page don't clash.
    var scope = thumb.closest(".product__primary-left") || document;

    // The same media id exists in both the mobile and desktop galleries; pick
    // the matching item that is actually visible (not `.hidden`, has layout).
    var items = scope.querySelectorAll(
      '.product__media-item[data-media-item-id="' + thumbnailId + '"]'
    );

    var targetVideo = null;
    items.forEach(function (item) {
      var video = item.querySelector("video");
      if (!video) return;
      var isVisible = !item.classList.contains("hidden") && item.offsetParent !== null;
      if (isVisible && !targetVideo) targetVideo = video;
    });

    // Pause every other product video (covers clicking an image thumbnail too).
    pauseAllExcept(scope, targetVideo);

    if (!targetVideo) return;

    // Try to play with sound (allowed because we're inside the click gesture);
    // fall back to muted autoplay if the browser blocks it.
    var attempt = targetVideo.play();
    if (attempt && typeof attempt.catch === "function") {
      attempt.catch(function () {
        targetVideo.muted = true;
        var retry = targetVideo.play();
        if (retry && typeof retry.catch === "function") retry.catch(function () {});
      });
    }
  }

  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-product-thumbnail]");
    if (!thumb) return;
    playProductVideoForThumbnail(thumb);
  });
})();

// ---------------------------------------------------------------------------
// Mobile product gallery (swiper carousel): auto-play the video on the active
// slide, pause it once swiped away. There are no thumbnails on mobile — slides
// are swiped. The theme's swiper `slideChange` already pauses the previously
// playing media but never plays the newly-active slide's video, and the swiper
// instance lives inside the minified bundle so we can't hook it directly.
// Instead we watch the `.swiper-slide-active` class (swiper toggles it on the
// active slide) and react with a MutationObserver. Mobile browsers block
// unmuted autoplay, so the carousel video is muted + playsinline.
// ---------------------------------------------------------------------------
(function () {
  var CAROUSEL = ".product__media-container.below-mobile.carousel";

  function pauseAll(carousel, keep) {
    carousel.querySelectorAll(".swiper-slide video").forEach(function (v) {
      if (v !== keep) {
        try {
          v.pause();
        } catch (e) {}
      }
    });
  }

  function syncActiveVideo(carousel) {
    var active = carousel.querySelector(".swiper-slide.swiper-slide-active");
    // Only react when the active slide actually changes. Calling play() makes
    // Plyr toggle its own classes, which would re-trigger the observer — this
    // guard stops that feedback loop.
    if (carousel.__lastActiveSlide === active) return;
    carousel.__lastActiveSlide = active;

    // Swiper loop clones aren't Plyr-initialised, so their <video> keeps the
    // native `controls` attribute. Strip it so cloned slides match the rest.
    carousel.querySelectorAll(".swiper-slide video[controls]").forEach(function (v) {
      v.removeAttribute("controls");
      v.controls = false;
    });

    var video = active ? active.querySelector("video") : null;
    pauseAll(carousel, video);
    if (!video) return;

    video.muted = true; // required for mobile autoplay
    video.playsInline = true;
    var p = video.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  }

  function initCarousel(carousel) {
    if (carousel.__videoAutoplayInit) return;
    carousel.__videoAutoplayInit = true;

    new MutationObserver(function () {
      syncActiveVideo(carousel);
    }).observe(carousel, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });

    // Handle the case where the first slide is already a video.
    syncActiveVideo(carousel);
  }

  function init() {
    document.querySelectorAll(CAROUSEL).forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

$(document).on('click', '.buy-now-btn', async function (e) {
        e.preventDefault();

        const btn = $(this);
        const form = btn.closest('form')[0];

        if (!form) {
          console.error('No form found for Buy Now button');
          return;
        }

        const formData = new FormData(form);

        const variantId = formData.get('id');
        const qty = formData.get('quantity') || 1;

        if (!variantId) {
          alert('Please select a variant');
          return;
        }

        try {
          // Clear cart

          // Add selected variant
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: qty,
            }),
          });

          // Redirect to checkout
          window.location.href = '/checkout';
        } catch (err) {
          console.error(err);
          alert('Something went wrong!');
        }
      });